/**
 * Labstep
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import { DataGrid } from 'labstep-web/core/DataGrid';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import type { SmartTableColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/types';
import { GridSmartTableColumnHeader } from 'labstep-web/grid/SmartTableProtocolCondition/components/ColumnHeader';
export const colDefProtocolConditionRowNumber: SmartTableColDef = {
  headerName: 'Condition #',
  colId: 'row_number',
  maxWidth: 50,
  lockPosition: 'left',
  cellRenderer: DataGrid.CellRenderer.RowNumber,
  cellStyle: { paddingLeft: 0, paddingRight: 0 },
  resizable: false,
  headerComponent: GridSmartTableColumnHeader,
  headerComponentParams: {
    icon: 'hashtag',
  },
  cellRendererParams: (
    params: CellRendererParams<SmartTableColDef>,
  ) => ({
    props: {
      action: (
        <EntityActionDelete
          dataCy="grid/SmartTableProtocolCondition/coldefs/protocol-condition/row-number:delete"
          entity={params.data}
          actionComponentProps={{ type: 'option' }}
          skipConfirmation
        />
      ),
    },
  }),
};
